<template>
    <div>
        <b-button
            variant="success"
            @click.stop="abrirModal()">
            <span>
                <i class="fa fa-plus mr-2"></i> Inserir Eventos
            </span>
        </b-button>
        <evento-form
            :mostrarModal="mostrarModal"
            :erros="erros"
            :acao="acao"
            @fechar="fecharModal()"
            @salvar="inserirEvento($event)"
        ></evento-form>
    </div>
</template>

<script>
import EventoForm from './EventoForm'
import EventosServicos from './EventosServicos'

export default {
    props: {
        acao: {
            type: Object,
            default: () => ({})
        }
    },

    components: {
        EventoForm
    },
    
    data() {
        return {
            mostrarModal: false,
            erros: [],
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        inserirEvento(evento){
            this.$store.dispatch('addRequest')
            let eventoDto = {
                codEvento : evento.codEvento,
                nomeEvento: evento.nomeEvento,
                idAcaoPlanoTrabalho: evento.idAcaoPlanoTrabalho
            }
            EventosServicos.inserirEvento(eventoDto)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Evento inserido com sucesso',
                            'OK',
                            this.$toastConfig.success)
                        this.$emit('atualizarLista')
                    } else {
                        this.$emit('atualizarErros', response.errors);
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },
    },
}
</script>
